import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';

import styles from './Face.module.less';

const getCardLinkItem = (item) => {
  if (item?.['@type'] !== 'Link') {
    return item;
  }

  const { remoteUrl, getRemoteUrl, ...linkItem } = item;
  return linkItem;
};

const Face = ({ className, item, isEditMode, handleFlip, children }) => {
  const classes = cx(styles.face, { [className]: className });

  return isEditMode ? (
    <div className={classes}>{children}</div>
  ) : (
    <UniversalLink className={classes} item={getCardLinkItem(item)}>
      {children}
    </UniversalLink>
  );
};

export default Face;
